import React from 'react';
import PropTypes from 'prop-types';

function LivenessCheckIcon({ className = '', width = 24, height = 24, strokeWidth = 1.75, ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      {...props}
    >
      <circle cx='12' cy='8' r='4' />
      <path d='M6 20v-1a6 6 0 0 1 12 0v1' />
    </svg>
  );
}

LivenessCheckIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default LivenessCheckIcon;
